export const INTEGRATINOS_TYPES = {
    RESCUE_TIME: "rescue-time",
    TOGGL: "toggl",
    OURA: "Oura",
    GARMIN: "Garmin",
    WHOOP: "Whoop",
    GOOGLE_FIT: "Google Fit",
}